import uri from 'urijs';

export default function getVideoEmbedThumbUrl({ thumbnail_url }) {
  return uri(thumbnail_url).protocol('').toString();
}
